import type { TOC } from '@ember/component/template-only';
import { t } from 'ember-intl';
import { PhUsers } from 'ember-phosphor-icons';
import HeroStat from 'tio-employee/components/dashboard-kit/hero-stat';
import type { WidgetComponentSignature } from 'tio-employee/utils/partner-dashboard/registry';

/** Hero tile: employees with an active tuition assistance participant record. */
const ActiveParticipantsWidget: TOC<WidgetComponentSignature<number>> = <template>
  <HeroStat
    @emphasis="metric"
    @label={{t "partner_dashboard.pulse.participants"}}
    @value={{@data}}
    @context={{t "partner_dashboard.pulse.participants_context"}}
    @contextIcon={{PhUsers}}
    data-test-partner-dashboard-active-participants
  />
</template>;

export default ActiveParticipantsWidget;
